

































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import Axios, { AxiosResponse } from 'axios';
import Spinner from '@/components/Spinner.vue';
import ConnectionErrorContent from '@/components/ConnectionErrorContent.vue';

export interface Recipe {
    title: string;
    categories: string[];
    ingredients: Ingredient[][];
    ingredientsTitle: string[];
    forValue: number;
    forType: string;
    directions: string;
    comments: string;
    images: string[];
}

export interface Ingredient {
    quantity: string;
    unit: string;
    ingredient: string;
}

export interface Category {
    id: string;
    title: string;
    image: string;
}

export interface CategoryListItem {
    id: string;
    title: string;
    active: boolean;
}

@Component({
  components: {
    Spinner,
    ConnectionErrorContent,
  },
})
export default class NewRecipe extends Vue {
    private status!: string;
    private recipe!: Recipe;
    private categories!: Category[];
    private categoryList!: CategoryListItem[];
    private categoryListShown!: CategoryListItem[];
    private error!: string;
    private selectedImages!: any[];
    private imgUploadProgress!: number;
    private filesAreSelected!: boolean;

    private data() {
        return {
            status: 'loading',
            recipe: {
                title: '',
                categories: [],
                ingredients: [],
                ingredientsTitle: [],
                forValue: '4',
                forType: 'Personen',
                directions: '',
                comments: '',
                images: [],
            },
            categoryList: [],
            categoryListShown: [],
            error: '',
            selectedImages: [],
            imgUploadProgress: 0,
            filesAreSelected: false,
        };
    }

    private created() {
        this.$store.state.mobileSidebarVisible = false;
        this.$store.state.menuVisible = false;
        this.loadData();
    }

    private loadData() {
        this.status = 'loading';
        this.recipe = {title: '', categories: [], ingredients: [[], [], [], []], ingredientsTitle: ['', '', '', ''], forValue: 4, forType: 'Personen', directions: '', comments: '', images: []};
        
        this.$http.get('categories/get/all').then((response: AxiosResponse) => {
            let allCategories: Category[] = [];
            this.categoryList = [];
			allCategories = response.data;
            for (let i = 0; i < allCategories.length; i++) {
                const element: CategoryListItem = {id: allCategories[i].id, title: allCategories[i].title, active: false};
                this.categoryList.push(element);
            }
            this.categoryListShown = this.categoryList.sort((a, b) => a.title.localeCompare(b.title));
            this.status = 'success';
        }).catch((error) => {
            this.status = 'error';
        });
    }

    private saveData() {
        if (this.selectedImages[0] !== undefined) {
            // sende Bild(er) + Rezept
            const formData = new FormData();
            formData.append('image', this.selectedImages[0]);
            this.$http.post('recipes/images/new', formData, {
                onUploadProgress: (uploadEvent) => {
                    this.imgUploadProgress = Math.round((uploadEvent.loaded / uploadEvent.total * 100));
                },
            })
            .then((response: AxiosResponse) => {
                this.imgUploadProgress = 0;
                if (response.data.msg === 'Success') {
                    this.recipe.images = response.data.imgIds;
                    this.sendRecipe();
                }
            });
        } else {
            // sende Rezept
            this.sendRecipe();
        }
    }

    private sendRecipe() {
        this.recipe.forValue = +this.recipe.forValue;
        for (let i = 0; i < this.categoryListShown.length; i++) {
            if (this.categoryListShown[i].active === true) {
                this.recipe.categories.push(this.categoryListShown[i].id);
            }
        }
        return Axios.post('recipes/new', this.recipe)
        .then((response) => {
            this.$store.state.recipeListStatus = 'loading';
            this.$store.dispatch('getRecipeList')
            .then((re) => {
                this.$store.state.recipeListShown = this.$store.state.recipeList.sort((a: any, b: any) => a.title.localeCompare(b.title));
                this.$store.state.recipeListStatus = 'success';
            }).catch((err) => {
                this.$store.state.recipeListStatus = 'error';
            });
            this.$router.push({ path: '/app/recipes/view/' + response.data.id});
        })
        .catch((e) => {
            this.error = e;
        });
    }

    private addIngredient(i: number) {
        const emptyIngredient: Ingredient = {quantity: '', unit: '', ingredient: ''};
        this.recipe.ingredients[i].push(emptyIngredient);
    }

    private removeIngredient(index: number, n: number) {
        this.recipe.ingredients[n].splice(index, 1);
    }
    
    private ingredientMoveUp(index: number, n: number) {
        if (index !== 0) {
            this.recipe.ingredients[n].splice(index - 1, 2, this.recipe.ingredients[n][index], this.recipe.ingredients[n][index - 1]);
        }
    }

    private ingredientMoveDown(index: number, n: number) {
        if (index !== this.recipe.ingredients[n].length - 1) {
            this.recipe.ingredients[n].splice(index, 2, this.recipe.ingredients[n][index + 1], this.recipe.ingredients[n][index]);
        }
    }

    private addRemoveCategory(category: CategoryListItem) {
        if (category.active === true) {
            for (let i = 0; i < this.categoryListShown.length; i++) {
                if (category.id === this.categoryListShown[i].id) {
                    this.categoryListShown[i].active = false;
                }
            }
        } else {
            for (let i = 0; i < this.categoryListShown.length; i++) {
                if (category.id === this.categoryListShown[i].id) {
                    this.categoryListShown[i].active = true;
                }
            }
        }
    }

    private onImagesSelected(event: any) {
        this.selectedImages = event.target.files;
        if (this.selectedImages[0] !== undefined) {
            this.filesAreSelected = true;
        }
    }

    private removeSelectedImages() {
        this.selectedImages = [];
        this.filesAreSelected = false;
    }
}
